module.exports = __webpack_public_path__ + "static/media/bonian_departments.22fc35f4.png";